import request from '@/utils/request';

// 获取用户信息Api
export function getCurrUserInfo() {
  return request({
    url: '/fundapis/uc/api/inetusers/me',
    method: 'get',
  });
}

// 获取管理员用户信息
export function getGmUserInfo(id) {
  // let username = id;
  // let input = document.createElement('input');
  // input.value = encodeURIComponent(username);
  // input.value = encodeURIComponent(input.value);
  // username = input.value;
  // input = null;

  const _id = id.replace('@', '%255C40');
  const url = `/fundapis/core/api/idsusers/${_id}%2540stcn`;

  return request({
    url,
    method: 'get',
    headers: {
      gwview: 1,
    },
  });
}

// 获取直播信息
export function queryLiveById(params) {
  return request({
    url: '/live/queryLiveById',
    method: 'get',
    baseURL: '',
    params,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

// 添加历史观看数，埋点
export function addWatchHistoryCount(liveId) {
  return request({
    url: `/live/addWatchHistoryCount?liveId=${liveId}`,
    method: 'get',
    baseURL: '',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

/* ******************************       聊天室开始        ********************************** */

// 聊天室发送信息
export function chatRoomSendMsg(params) {
  return new Promise((resolve, reject) => request({
    url: '/fundapis/comment/api/comments/liveStream',
    method: 'post',
    baseURL: '',
    data: params
  })
    .then((res) => {
      if (res.code === 200) {
        const { data } = res;
        resolve(data);
      } else {
        reject()
      }
    })
    .catch((e) => {
      reject();
    }));
}

// 获取直播间评论列表
export function chatRoomGetMsgList(params) {
  const _params = { ...params }
  const { roomId } = _params;
  return new Promise((resolve, reject) => request({
    url: `/fundapis/comment/api/comments/liveStream/${roomId}`,
    method: 'get',
    baseURL: '',
    params: {
      page: _params.page,
      size: _params.size
    }
  })
    .then((res) => {
      if (res.code === 200) {
        const { data } = res;
        resolve(data);
      } else {
        reject()
      }
    })
    .catch((e) => {
      reject();
    }));
}

// 获取直播间评论总数
export function chatRoomGetMsgListSum(params) {
  const { roomId } = params;
  return new Promise((resolve, reject) => request({
    url: `/fundapis/comment/api/comments/liveStream/${roomId}/count`,
    method: 'get',
    baseURL: '',
  })
    .then((res) => {
      if (res.code === 200) {
        const { data } = res;
        resolve(data);
      } else {
        reject()
      }
    })
    .catch((e) => {
      reject();
    }));
}

// 更改消息状态
export function updateLiveStreamType(params) {
  const { id, type } = params;
  return new Promise((resolve, reject) => request({
    url: `/fundapis/comment/api/comment/updateLiveStreamType/${id}?type=${type}`,
    method: 'post',
    baseURL: '',
  })
    .then((res) => {
      if (res.code === 200) {
        resolve();
      } else {
        reject()
      }
    })
    .catch((e) => {
      reject();
    }));
}


/* ******************************       聊天室结束        ********************************** */


/* ******************************       图文直播开始        ********************************** */

// 图文直播发送信息
export function tuwenRoomSendMsg(params) {
  return new Promise((resolve, reject) => request({
    url: '/fundapis/comment/api/liveStream',
    method: 'post',
    baseURL: '',
    data: params
  })
    .then((res) => {
      if (res.code === 200) {
        const { data } = res;
        resolve(data);
      } else {
        reject()
      }
    })
    .catch((e) => {
      reject();
    }));
}

// 图文直播置顶消息
export function tuwenRoomSetTopMsg(params) {
  return new Promise((resolve, reject) => request({
    url: '/fundapis/comment/api/liveStream',
    method: 'put',
    baseURL: '',
    data: params
  })
    .then((res) => {
      if (res.code === 200) {
        const { data } = res;
        resolve(data);
      } else {
        reject()
      }
    })
    .catch((e) => {
      reject();
    }));
}

// 获取图文直播列表
export function tuwenRoomGetMsgList(params) {
  return new Promise((resolve, reject) => request({
    url: '/fundapis/comment/api/liveStream/article/',
    method: 'get',
    baseURL: '',
    params: {
      targetType: 'liveStream',
      liveStreamId: params.roomId,
      page: params.page,
      size: params.size
      // sort: params.sort
    }
  })
    .then((res) => {
      if (res.code === 200) {
        const { data } = res;
        resolve(data);
      } else {
        reject()
      }
    })
    .catch((e) => {
      reject();
    }));
}

// 获取图文直播总数
export function tuwenRoomGetMsgListSum(params) {
  const { roomId } = params;
  return new Promise((resolve, reject) => request({
    url: '/fundapis/comment/api/liveStream/article/count',
    method: 'get',
    baseURL: '',
    params: {
      targetType: 'liveStream',
      liveStreamId: roomId,
    }
  })
    .then((res) => {
      if (res.code === 200) {
        const { data } = res;
        resolve(data);
      } else {
        reject()
      }
    })
    .catch((e) => {
      reject();
    }));
}

export function tuwenRoomDelMsg(params) {
  const { roomId, id } = params;
  return new Promise((resolve, reject) => request({
    url: `/fundapis/comment/api/liveStream/${id}`,
    method: 'delete',
    baseURL: '',
    params: {
      targetType: 'liveStream',
      liveStreamId: roomId,
    }
  })
    .then((res) => {
      if (res.code === 200) {
        resolve();
      } else {
        reject()
      }
    })
    .catch((e) => {
      reject();
    }));
}

/* ******************************       图文直播结束        ********************************** */

